import styled from 'styled-components';
import { MTimerAlignment } from './MTimer.types';

// Using same baseVariables pattern as other cobrand components
const spacers = {
  spacers: {
    1: '0.25rem',
    3: '1rem',
  },
};

export const Wrapper = styled.div<{ alignment?: MTimerAlignment }>`
  display: ${({ alignment }) => (alignment ? 'flex' : 'inline-flex')};
  flex-direction: ${({ alignment }) => (alignment ? 'column' : 'row')};
  align-items: ${({ alignment }) =>
    alignment === MTimerAlignment.Centered ? 'center' : alignment === MTimerAlignment.Left ? 'flex-start' : 'center'};
  gap: ${({ alignment }) => (alignment ? '8px' : spacers.spacers[1])};
  color: inherit;
`;

export const SkeletonWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${spacers.spacers[1]};
  color: inherit;

  /* Skeleton loader styles following repo pattern */
  @keyframes react-loading-skeleton {
    100% {
      transform: translateX(100%);
    }
  }

  .react-loading-skeleton {
    --base-color: var(--t-neutral-color-10, #ebebeb);
    --highlight-color: var(--t-neutral-color-05, #f5f5f5);
    --animation-duration: 1.5s;
    --animation-direction: normal;
    --pseudo-element-display: block;

    background-color: var(--base-color);
    border-radius: ${spacers.spacers[1]};
    display: inline-flex;
    position: relative;
    user-select: none;
    overflow: hidden;
  }

  .react-loading-skeleton::after {
    content: ' ';
    display: var(--pseudo-element-display);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    background-repeat: no-repeat;
    background-image: linear-gradient(90deg, var(--base-color) 0%, var(--highlight-color) 50%, var(--base-color) 100%);
    transform: translateX(-100%);
    animation-name: react-loading-skeleton;
    animation-direction: var(--animation-direction);
    animation-duration: var(--animation-duration);
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
  }

  @media (prefers-reduced-motion) {
    .react-loading-skeleton {
      --pseudo-element-display: none;
    }
  }
`;

export const TimerDisplay = styled.div`
  display: flex;
  align-items: flex-start; /* Align to top so separators align with digits */
  gap: ${spacers.spacers[1]};
  color: inherit;
`;

export const TimerUnit = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: ${spacers.spacers[1]};
  color: inherit;

  /* Force labels to be uppercase */
  p,
  span {
    text-transform: uppercase;
  }
`;

export const SkeletonDigit = styled.div`
  padding-block-end: ${spacers.spacers[1]}; /* Match ADigit Large padding-block-end */
  display: inline-block;
  font-size: 1.875rem; /* Match ADigit Large font-size (30px) */
  line-height: 1; /* Match ADigit line-height */
  font-weight: 700; /* Match ADigit font-weight */
  width: auto;
  min-height: 1.875rem; /* Ensure consistent height */
`;

export const SkeletonLabel = styled.div`
  padding-block-end: ${spacers.spacers[1]}; /* Match ABody padding-block-end */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  line-height: 1.5; /* Match ABody line-height */
  font-size: 0.75rem; /* Match ABody XS (12px) */
  min-height: 0.75rem;
`;

export const Separator = styled.span`
  font-size: 1.375rem; /* 22px to match timer digit size */
  font-weight: 500;
  line-height: 1.25; /* Match digit line-height from Figma */
  color: inherit;
  padding: 0 0.125rem;
  padding-bottom: ${spacers.spacers[1]}; /* Align with digit padding */
  font-family: var(--t-font-family);
`;

export const ScreenReaderOnly = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
`;
